import {XH} from '@xh/hoist/core';

/**
 * Display style chosen via the `uiStyle` preference. `terminal` is the dense, trading-screen look
 * (solid colored cells, convex ticker badges). `standard` is a lighter look with colored text only.
 *
 * Changing the pref requires a reload. The style is applied as a `rzx-style--<style>` class on the
 * body, so purely visual rules can be scoped in SCSS. Code checks `isTerminalStyle()` only where
 * the structure differs.
 */
export type UiStyle = 'standard' | 'terminal';

export function uiStyle(): UiStyle {
    return XH.getPref('uiStyle', 'terminal') === 'standard' ? 'standard' : 'terminal';
}

export function isTerminalStyle(): boolean {
    return uiStyle() === 'terminal';
}

export function applyUiStyleClass() {
    document.body.classList.add(`rzx-style--${uiStyle()}`);
}
